export interface NavItem {
  label: string;
  href: string;
}

export const navItems: NavItem[] = [
  { label: 'Home', href: '/' },
  { label: 'Shopping Guide', href: '#categories' },
  { label: 'Guide', href: '/vigorbuy-spreadsheet-guide' },
  { label: 'Review', href: '/vigorbuy-spreadsheet-review' },
  { label: 'Templates', href: '/vigorbuy-spreadsheet-templates' },
  { label: 'Security', href: '/vigorbuy-spreadsheet-security' },
  { label: 'Comparison', href: '/vigorbuy-spreadsheet-comparison' },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';